import { SVGProps } from 'react';

const Timer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10 2h4m-2 12 3-3m5 3a8 8 0 1 1-16 0 8 8 0 0 1 16 0"
    />
  </svg>
);
export default Timer;
